import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

import './component.scss'
import './images/troubled_face_man.svg'
import './images/troubled_face_woman.svg'
import './images/troubled_face_middle_age.svg'
import './images/answer_icon.svg'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

const app = Application.start()

app.register(
  'company-qa',
  class extends Controller {
    static targets = ['expandButton', 'answer', 'expandArrow']

    toggle(event) {
      const expandButton = event.currentTarget
      const index = expandButton.dataset.index

      const answerElements = this.answerTargets
      const expandArrowElements = this.expandArrowTargets
      
      // インデックスに基づいて対象要素を特定
      // Q2 = index 1, Q3 = index 2
      const targetAnswerIndex = parseInt(index) - 1
      const targetArrowIndex = parseInt(index) - 1
      
      const answerElement = answerElements[targetAnswerIndex]
      const arrowElement = expandArrowElements[targetArrowIndex]

      if (answerElement && arrowElement) {
        // 一度展開したら閉じない
        answerElement.classList.remove('is-hidden')
        arrowElement.classList.add('is-open')

        expandButton.style.display = 'none'
      }
    }
  }
)
